module.exports = __webpack_public_path__ + "static/img/zncssb-bg.3613594.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/zncssb-bg.png
// module id = U4UD
// module chunks = 96